"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var components_1 = require("components");
var MapStoreToProps = function (store /*, ownProps: any*/) {
    return {
        images: store.UI.environments.available.map(function (e) { return e.image; })
    };
};
exports.default = react_redux_1.connect(MapStoreToProps)(components_1.PreloadImages);
//# sourceMappingURL=PreloadEnvironments.js.map